export default "\n<h2>Customers</h2>\n<hr>\n<app-table></app-table>\n\n";